import { InjectionToken, isDevMode } from '@angular/core';

export const EDITOR_DEBUG = new InjectionToken<boolean>('EDITOR_DEBUG', {
  providedIn: 'root',
  factory: () => isDevMode()
});
